module.exports = __webpack_public_path__ + "./img/ofertaAnticongelante.80c012cc27aacb8118a3bc513aaac2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/modal/ofertaAnticongelante.png
// module id = ./src/assets/img/modal/ofertaAnticongelante.png
// module chunks = 14